<template>
	<div class="reserve-background-width">
		<v-img
			v-if="eventsData.eventImg"
			:src="$store.state.frontServer_upload + eventsData.eventImg.url"
			@error="imgError()"
			class="imageButton"
		>
		</v-img>
		<v-img v-else-if="eventsData.eventImg === null" :src="defaultImg" class="imageButton"> </v-img>

		<div class="reserveInfo">
			{{ eventsData.title }} <br />
			이벤트 참여기간 : {{ eventsData.start | moment('YYYY.MM.DD (ddd)') }} ~
			<span v-if="eventsData.showInfo">
				{{ eventsData.end | moment('YYYY.MM.DD (ddd)') }}
			</span>
		</div>
		<v-layout class="pa-4" wrap justify-center>
			<v-flex xs12>
				<btn
					:btn="nextbtn"
					:btn_txt="eventsData.btnText ? eventsData.btnText : '시작하기'"
					:style="`color:${$store.state.PointColor8}`"
					@click="startSurvey"
				></btn>
			</v-flex>
		</v-layout>
		<!-- 이름 전화 번호 입력 모달 -->
		<reserveStart :setdialog="startDialog" :reservedaysData="eventsData" :nextStep="nextStep"></reserveStart>
		<!-- 드래그 버전 설문 모달 -->
		<reservevisitModalEvent
			:setdialog="reserveDialog"
			:title="placeTitle"
			:eventsData="eventsData"
			@cancle="events()"
		></reservevisitModalEvent>

		<alertModal5 :setdialog="alertModal" />
		<alertModal5 :setdialog="alertModal2" />
		<previewEventTalk :setdialog="previewEventTalk" />
	</div>
</template>

<script>
import { alertModal5, btn, previewEventTalk, reserveStart, reservevisitModalEvent } from '@/components/index.js'
import location1 from '../../utils/location1'
import location2 from '../../utils/location2'
export default {
	components: {
		btn,
		reserveStart,
		previewEventTalk,
		reservevisitModalEvent,
		alertModal5,
	},
	metaInfo() {
		return {
			// 페이지 제목 캠페인 명에 따라 변경
			title: this.campaignTitle,
		}
	},
	data() {
		return {
			defaultImg: require('@/../public/image/default_main.png'),
			previewEventTalk: {
				dialog: false,
				modalIcon: 'success',
				title: '',
				content: '',
			},
			placeTitle: '',
			nametxtField: { value: '', outlined: true, placeholder: '성명을 입력하세요.' },
			numSel: { value: '010', outlined: true, class: 'selectNum', items: ['010', '011', '016', '017'] },
			numtxtField: { value: '', outlined: true, placeholder: '나머지 번호를 입력하세요', onlyNumber: true, maxlength: 8 },
			nextbtn: {
				block: true,
				large: true,
				class: 'customBtn',
				color: this.$store.state.PointColor7,
			},
			backbtn: {
				block: true,
				large: true,
				class: 'selectBtn',
			},
			reserveDialog: {
				title: '예약정보',
				dialog: false,
				step1: true,
				step2: false,
				step3: false,
				name: '',
				inputUserData: {
					name: '',
					phone: '',
				},
			},
			reserveDialog1: {
				title: '예약정보',
				dialog: false,
				step1: true,
				step2: false,
				step3: false,
				name: '',
				inputUserData: {
					name: '',
					phone: '',
				},
			},
			startDialog: {
				step1: true,
				dialog: false,
				nametxtField: { value: '', outlined: true, placeholder: '성명을 입력하세요.', color: 'black' },
				numSel: { value: '010', outlined: true, class: 'selectNum', items: ['010', '011', '016', '017'], color: 'black' },
				numtxtField: {
					value: '',
					outlined: true,
					placeholder: '나머지 번호를 입력하세요',
					onlyNumber: true,
					maxlength: 8,
					color: 'black',
					max: 99999999,
					type: 'Number',
				},
				phonetxtField: {
					value: '',
					outlined: true,
					placeholder: '문자로 전송된 인증번호를 입력하세요',
					onlyNumber: true,
					maxlength: 6,
					color: 'black',
					max: 99999999,
					type: 'Number',
				},
			},
			trackingCodes: [],
			eventsData: { business: { QRlogo: null } },
			alertModal: {
				dialog: false,
				text: '이름과 전화번호를 입력해 주세요.',
			},
			alertModal2: {
				dialog: false,
				text: '',
			},
			noInputBox: false,
			campaignTitle: '',
			surveyLegnth: 0,

			message: '',
		}
	},
	async created() {
		this.$moment.locale('ko', {
			weekdays: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
			weekdaysShort: ['일', '월', '화', '수', '목', '금', '토'],
		})

		await this.events()
	},
	methods: {
		loc_firstSelect(val) {
			this.$store.state.searchsel_city2.items = location1[val].sort()
		},
		loc_twoSelect(val) {
			this.$store.state.searchsel_city3.items = location2[this.$store.state.searchsel_city1.value][val].sort()
		},
		imgError() {
			this.eventsData.mainimg = null
		},
		getLength() {
			let index = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 90)
			if (index !== -1) {
				this.surveyLegnth = this.$store.state.reservedayInputBox.categories.length - 1
				this.$store.state.reservedayInputBox.categories.splice(index, 1)
			} else {
				this.surveyLegnth = this.$store.state.reservedayInputBox.categories.length
			}
			let dateIndex = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 30)
			if (dateIndex !== -1) {
				this.$store.state.reservedayInputBox.categories.splice(dateIndex, 1)
				this.surveyLegnth--
			}
			let timeIndex = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 31)
			if (timeIndex !== -1) {
				this.$store.state.reservedayInputBox.categories.splice(timeIndex, 1)
				this.surveyLegnth--
			}
		},
		createTrackingCode() {
			const data = {
				name: this.startDialog.nametxtField.value,
				phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
			}
			this.$store
				.dispatch('createTrackingCode', data)
				.then(res => {
					this.$store.state.trackingCodeId = res.data.createTrackingCode.trackingCode.id
					if (!this.eventsData.population) {
						if (this.eventsData.accessPhones !== '' && this.eventsData.accessPhones !== null) {
							this.checkPhone()
						} else {
							this.eventJoins()
						}
					} else {
						this.checkPopulation()
					}
				})
				.catch(() => {})
		},
		async events() {
			const data = {
				code: this.$route.params.code,
			}
			await this.$store
				.dispatch('events', data)
				.then(res => {
					if (res.data.events[0].population) {
						let text_copy = JSON.parse(JSON.stringify(res.data.events[0].population))
						res.data.events[0].populationType = text_copy.split('_')[0]
						res.data.events[0].population = text_copy.split('_')[1]
					}

					this.eventsData = res.data.events[0]
					this.eventsData.sdate = res.data.events[0].start
					this.eventsData.edate = res.data.events[0].end
					if (res.data.events[0].business) {
						let li = []
						if (res.data.events[0].business.useTerm) {
							li.push(res.data.events[0].business.useTerm)
						} else li.push(null)
						if (res.data.events[0].business.privacyTerm_event) {
							li.push(res.data.events[0].business.privacyTerm_event)
						} else li.push(null)
						if (res.data.events[0].business.uniqueTerm) {
							li.push(res.data.events[0].business.uniqueTerm)
						} else li.push(null)
						if (res.data.events[0].business.marketingTerm_event) {
							li.push(res.data.events[0].business.marketingTerm_event)
						} else li.push(null)
						if (res.data.events[0].business.adTerm) {
							li.push(res.data.events[0].business.adTerm)
						} else li.push(null)

						this.$store.state.termIdList = li
					}
					if (res.data.events[0].term) this.$store.state.termId = res.data.events[0].term.id
					// events data 초기화
					this.$store.state.reservedayData = res.data.events[0]
					if (res.data.events[0].business.color) {
						this.$store.state.PointColor7 = res.data.events[0].business.color
						this.nextbtn.color = res.data.events[0].business.color

						this.startDialog.nametxtField.color = res.data.events[0].business.color
						this.startDialog.numSel.color = res.data.events[0].business.color
						this.startDialog.numtxtField.color = res.data.events[0].business.color
					}
					if (res.data.events[0].business.btnColor) {
						this.$store.state.PointColor8 = res.data.events[0].business.btnColor
					}
					if (res.data.events[0].input_box !== null) {
						this.placeTitle = res.data.events[0].title
						this.campaignTitle = res.data.events[0].title
						res.data.events[0].input_box.categories.forEach(element => {
							if (element.tag === 'location') {
								if (element.defalutLocation) {
									this.$store.state.searchsel_city1.value = element.defalutLocation.split('_')[0]
									this.loc_firstSelect(element.defalutLocation.split('_')[0])
									if (element.defalutLocation.split('_')[1]) {
										this.loc_twoSelect(element.defalutLocation.split('_')[1])
										this.$store.state.searchsel_city2.value = element.defalutLocation.split('_')[1]
									}
									if (element.defalutLocation.split('_')[2]) {
										this.$store.state.searchsel_city3.value = element.defalutLocation.split('_')[2]
									}
								} else {
									this.$store.state.searchsel_city2.items = location1['서울특별시'].sort()
									this.$store.state.searchsel_city3.items = location2['서울특별시']['강남구'].sort()
								}
							}
							if (element.type === 10) {
								element.imgType = element.imgType ? element.imgType : '리스트형'
								element.value = ''
								element.items = { value: '', maxlength: '200', outlined: true, autofocus: false, hideDetail: true, errorMessage: '' }
								element.nowRadioValue = ''
								element.etc = ''
								if (element.detailImg) {
									element.detailImg.url = process.env.VUE_APP_CUSTOMER_URL + element.detailImg.url
								}
								if (element.previewImg) {
									element.previewImg.url = process.env.VUE_APP_CUSTOMER_URL + element.previewImg.url
								}
								element.category_details.forEach(detail => {
									if (detail.detailImg) {
										detail.detailImg.url = process.env.VUE_APP_CUSTOMER_URL + detail.detailImg.url
									}
									if (detail.previewImg) {
										detail.previewImg.url = process.env.VUE_APP_CUSTOMER_URL + detail.previewImg.url
									}
								})
							} else if (element.type === 11) {
								element.imgType = element.imgType ? element.imgType : '리스트형'
								if (element.detailImg) {
									element.detailImg.url = process.env.VUE_APP_CUSTOMER_URL + element.detailImg.url
								}
								if (element.previewImg) {
									element.previewImg.url = process.env.VUE_APP_CUSTOMER_URL + element.previewImg.url
								}
								element.category_details.forEach(detail => {
									if (!element.items) {
										element.items = []
									}
									element.items.push({
										value: '',
										label: detail.detailname,
										color: '',
										class: '',
										errorMessage: '',
										hideDetail: true,
										detailcode: detail.detailcode,
									})
									if (detail.detailImg) {
										detail.detailImg.url = process.env.VUE_APP_CUSTOMER_URL + detail.detailImg.url
									}
									if (detail.previewImg) {
										detail.previewImg.url = process.env.VUE_APP_CUSTOMER_URL + detail.previewImg.url
									}
								})
							} else if (element.type === 12) {
								element.items = {
									label: '',
									value: '',
									errorMessage: '',
									hideDetail: true,
									outlined: true,
									color: this.$store.state.PointColor7,
								}
							} else if (element.type === 20) {
								element.items = {
									value: '',
									maxlength: '255',
									outlined: true,
									autofocus: false,
									hideDetail: false,
									errorMessage: '',
									color: this.$store.state.PointColor7,
								}
								if (element.detailImg) {
									element.detailImg.url = process.env.VUE_APP_CUSTOMER_URL + element.detailImg.url
								}
								if (element.previewImg) {
									element.previewImg.url = process.env.VUE_APP_CUSTOMER_URL + element.previewImg.url
								}
							}
						})
					} else {
						this.noInputBox = true
						this.campaignTitle = res.data.events[0].title
						this.placeTitle = res.data.events[0].title
					}
					this.$store.commit('reservedayInputBox', res.data.events[0].input_box)
					this.$store.commit('maxcount', res.data.events[0].maxcount)
					this.$store.commit('startDate', res.data.events[0].start)
					this.$store.commit('endDate', res.data.events[0].end)
					this.getLength()
				})
				.catch(() => {})
		},

		randomItem(item) {
			return item[Math.floor(Math.random() * item.length)]
		},
		shuffle(array) {
			return array.sort(() => Math.random() - 0.5)
		},
		eventJoins() {
			const data = {
				phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
				code: this.$route.params.code,
			}

			this.$store
				.dispatch('eventJoins', data)
				.then(res => {
					if (res.data.eventJoins.length === 0) {
						// eventJoins에 입력한 정보의 참가자가 없는 경우
						if (this.eventsData.input_box !== null) {
							this.reserveDialog.title = this.eventsData.input_box.name
						}
						if (this.eventsData.input_box) {
							this.startDialog.dialog = false
							this.reserveDialog.dialog = true
							this.reserveDialog.step1 = true
							this.reserveDialog.step2 = false
						} else {
							this.reserveDialog.step1 = false
							this.reserveDialog.step2 = true
							this.createEventJoin()
						}
					} else {
						// eventJoins에 입력한 정보의 참가자가 있는 경우
						if (this.eventsData.duplicate) {
							// 캠페인 중복 참가 가능한 경우 -> duplicate 값이 true
							if (this.eventsData.input_box !== null) {
								this.reserveDialog.title = this.eventsData.input_box.name
							}
							if (this.eventsData.inputBoxType === '2') {
								this.reserveDialog1.dialog = true
								this.startDialog.dialog = false
							} else {
								if (this.eventsData.input_box) {
									this.startDialog.dialog = false
									this.reserveDialog.dialog = true
									this.reserveDialog.step1 = true
									this.reserveDialog.step2 = false
								} else {
									this.reserveDialog.step1 = false
									this.reserveDialog.step2 = true
									this.createEventJoin()
								}
							}
						} else {
							this.eventsData.duplicate = false
							// 캠페인 중복 참가 불가능한 경우 -> duplicate 값이 false
							this.alertModal2.text = '고객님은 해당 이벤트에 이미 참여하셨습니다. (중복참여 불가)'
							this.alertModal2.dialog = true
						}
					}
				})
				.catch(() => {
					this.$store.state.loading = false
				})
		},
		startSurvey() {
			this.startDialog.nametxtField.value = ''
			this.startDialog.numSel.value = '010'
			this.startDialog.numtxtField.value = ''
			this.startDialog.phonetxtField.value = ''
			if (this.noInputBox === false) {
				this.maxcountCheck()
			} else {
				this.alertModal.text = '해당 이벤트는 문항이 없어 참여하실 수 없습니다'
				return (this.alertModal.dialog = true)
			}
		},
		nextStep() {
			if (this.startDialog.nametxtField.value === '') {
				this.alertModal.text = '이름과 전화번호를 입력해 주세요.'
				return (this.alertModal.dialog = true)
			}
			if (this.startDialog.numtxtField.value === '') {
				this.alertModal.text = '이름과 전화번호를 입력해 주세요.'
				return (this.alertModal.dialog = true)
			}

			if (this.startDialog.numtxtField.value.length < 7) {
				this.alertModal.text = '휴대전화번호를 정확히 입력해주세요.'
				return (this.alertModal.dialog = true)
			}

			this.reserveDialog.inputUserData = {
				name: this.startDialog.nametxtField.value,
				phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
			}
			this.reserveDialog1.inputUserData = {
				name: this.startDialog.nametxtField.value,
				phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
			}

			if (!this.eventsData.population || this.eventsData.population === '설정 해제') {
				if (this.eventsData.accessPhones !== '' && this.eventsData.accessPhones !== null) {
					this.checkPhone()
				} else {
					this.eventJoins()
				}
			} else {
				this.checkPopulation()
			}
		},
		changeTypeText(data) {
			if (data === 11) {
				return 'checkbox'
			} else if (data === 10 || data === 12) {
				return 'checkone'
			} else if (data === 20) {
				return 'textfiled'
			}
		},
		change() {
			return {}
		},
		disableNext() {
			if (this.startDialog.numtxtField.value && this.startDialog.nametxtField.value) {
				this.nextbtn.disabled = false
			} else {
				this.nextbtn.disabled = true
			}
			this.reserveDialog.name = this.startDialog.nametxtField.value
		},
		clickdoneBtn() {
			this.reserveDialog.dialog = false
		},
		maxcountCheck() {
			this.$store.state.loading = true
			const data = {
				code: this.$route.params.code,
				dropout: false,
			}
			this.$store
				.dispatch('eventJoinCount', data)
				.then(res => {
					let reserveAmount = res
					this.$store.state.loading = false
					if (
						this.$moment(this.$moment().format('YYYY-MM-DD')).isBetween(
							this.$moment().format('YYYY-MM-DD'),
							this.eventsData.end.substring(0, 10),
							undefined,
							'[]',
						)
					) {
						if (
							this.$moment(this.$moment().format('YYYY-MM-DD')).isBetween(
								this.eventsData.start.substring(0, 10),
								this.$moment().format('YYYY-MM-DD'),
								undefined,
								'[]',
							)
						) {
							// let useYnFalseCount = 0
							// for (let index2 = 0; index2 < this.eventsData.priceList.length; index2++) {
							// 	if (this.eventsData.priceList[index2].useYn) {
							// 		console.log(this.eventsData.priceList[index2].useYn, this.eventsData.priceList[index2].winnerNumber)
							// 		useYnFalseCount += this.eventsData.priceList[index2].winnerNumber
							// 	}
							// }
							if (reserveAmount >= this.eventsData.maxcount) {
								this.alertModal2.text = '본 이벤트는 종료되었습니다.'
								this.alertModal2.dialog = true
							} else {
								this.startDialog.dialog = true
							}
						} else {
							this.alertModal2.text = '본 이벤트는 시작 전입니다.'
							this.alertModal2.dialog = true
						}
					} else {
						this.alertModal2.text = '본 이벤트는 종료되었습니다.'
						this.alertModal2.dialog = true
					}
				})
				.catch(() => {
					this.$store.state.loading = false
				})
		},
		checkPopulation() {
			let input
			if (this.$store.state.reservedayData.populationType === 'e') {
				input = {
					code: this.$store.state.reservedayData.population,
				}
				this.$store
					.dispatch('eventJoins', input)
					.then(res => {
						if (res.data.eventJoins.length === 0) {
							this.alertModal.text = '해당 서비스의 참여 대상이 아닙니다.'
							return (this.alertModal.dialog = true)
						} else {
							let inputData = {
								phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
								code: this.$store.state.reservedayData.population,
							}
							this.$store.dispatch('eventJoins', inputData).then(res => {
								if (res.data.eventJoins.length > 0) {
									this.eventJoins()
								} else {
									this.alertModal.text = '해당 서비스의 참여 대상이 아닙니다.'
									return (this.alertModal.dialog = true)
								}
							})
						}
					})
					.catch(() => {
						this.$store.state.loading = false
					})
			} else {
				input = {
					phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
					code: this.$store.state.reservedayData.population,
				}
				this.$store
					.dispatch('findReserveusers', input)
					.then(res => {
						if (res.data.reserveusers.length === 0) {
							this.alertModal.text = '해당 서비스의 참여 대상이 아닙니다.'
							return (this.alertModal.dialog = true)
						} else {
							this.eventJoins()
						}
					})
					.catch(() => {
						this.$store.state.loading = false
					})
			}
		},
		checkPhone() {
			let phone = this.startDialog.numSel.value + this.startDialog.numtxtField.value
			let realPhone = phone
				.replace(/[^0-9]/g, '')
				.replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, '$1-$2-$3')
				.replace('--', '-')
			let nameCheck = this.eventsData.accessPhones.map(x => x.phone).indexOf(realPhone)
			if (nameCheck !== -1) {
				this.eventJoins()
			} else {
				this.alertModal.text = '해당 서비스의 참여 대상이 아닙니다.'
				this.alertModal.dialog = true
				this.startDialog.dialog = false
			}
		},
		isMobile() {
			const ua = navigator.userAgent
			if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
				return 'tablet'
			} else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
				return 'mobile'
			}
			return 'desktop'
		},
		closePage() {
			window.open('about:blank', '_self').close()
			if (this.isMobile() !== 'desktop') {
				location.href = 'kakaotalk://inappbrowser/close'
			}
		},
		createEventJoin() {
			const data = {
				code: this.$route.params.code,
			}
			this.$store.dispatch('eventJoins', data).then(res => {
				let map = []
				let priceProductCount = 0
				let useYnFalseCount = 0
				for (let index2 = 0; index2 < this.eventsData.priceList.length; index2++) {
					if (this.eventsData.priceList[index2].useYn) {
						priceProductCount += this.eventsData.priceList[index2].winnerNumber
						for (let index3 = 0; index3 < this.eventsData.priceList[index2].winnerNumber; index3++) {
							map.push({
								auto: this.eventsData.priceList[index2].auto ? this.eventsData.priceList[index2].auto : null,
								product: this.eventsData.priceList[index2].product,
								winnder: true,
							})
						}
					} else useYnFalseCount += this.eventsData.priceList[index2].winnerNumber
				}
				for (
					let index = 0;
					index < this.eventsData.maxcount - priceProductCount - useYnFalseCount - res.data.eventJoins.filter(x => !x.winner).length;
					index++
				) {
					map.push({
						product: '',
						winnder: false,
					})
				}
				for (let index = 0; index < res.data.eventJoins.filter(x => x.winner).length; index++) {
					const eventJoinIndex = map.map(x => x.product).indexOf(res.data.eventJoins.filter(x => x.winner)[index].winnterProduct)
					map.splice(eventJoinIndex, 1)
				}
				let data2 = {}
				const mapData = this.randomItem(this.shuffle(map))
				if (mapData) {
					if (mapData.winnder) {
						const now = new Date()
						const today = this.$moment(now).format('YYYY년 MM월 DD일 HH:mm')
						let alertTalkmessage = this.eventsData.message.message
						alertTalkmessage = alertTalkmessage.replace(/#{사업지명}/g, this.eventsData.business.title)
						alertTalkmessage = alertTalkmessage.replace(/#{고객명}/g, this.reserveDialog.inputUserData.name)
						alertTalkmessage = alertTalkmessage.replace(/#{이벤트당첨일시}/g, today)
						alertTalkmessage = alertTalkmessage.replace(/#{상품명}/g, mapData.product)
						alertTalkmessage = alertTalkmessage.replace(/#{이벤트명}/g, this.placeTitle)
						alertTalkmessage = alertTalkmessage.replace(/#{대표번호}/g, this.eventsData.callerNumber)
						this.eventsData.message.message = alertTalkmessage
						data2 = {
							name: this.reserveDialog.inputUserData.name,
							phone: this.reserveDialog.inputUserData.phone,
							event: this.eventsData.id,
							eventTitle: this.placeTitle,
							winner: true,
							winnterTitle: mapData.product,
							winnterProduct: mapData.product,
							alertTalkmessage: alertTalkmessage,
							code: this.$route.params.code,
							locationData:
								this.$store.state.reservedayInputBox.categories.map(x => x.type).indexOf(20) > -1
									? this.$store.state.searchsel_city1.value +
									  '_' +
									  this.$store.state.searchsel_city2.value +
									  '_' +
									  this.$store.state.searchsel_city3.value
									: '',
						}
						if (mapData.auto) {
							data2.receipt = '수령'
							data2.receiptDate = new Date(new Date().setHours(new Date().getHours() + 9))
						}
					} else {
						data2 = {
							name: this.reserveDialog.inputUserData.name,
							phone: this.reserveDialog.inputUserData.phone,
							event: this.eventsData.id,
							eventTitle: this.placeTitle,
							code: this.$route.params.code,
							locationData:
								this.$store.state.reservedayInputBox.categories.map(x => x.type).indexOf(20) > -1
									? this.$store.state.searchsel_city1.value +
									  '_' +
									  this.$store.state.searchsel_city2.value +
									  '_' +
									  this.$store.state.searchsel_city3.value
									: '',
						}
					}
					this.$store.dispatch('createEventJoin', data2).then(() => {
						this.startDialog.dialog = false
						if (this.eventsData.endLink) this.previewEventTalk.endLink = this.eventsData.endLink
						if (mapData.winnder) {
							this.previewEventTalk.title = '이벤트 당첨안내'
							this.previewEventTalk.content = this.eventsData.winnerMessage.replace('{상품명}', mapData.product)
							this.creaetSendMessage()
						} else {
							this.previewEventTalk.title = '이벤트 결과안내'
							this.previewEventTalk.content = this.eventsData.joinMessage
						}
						this.previewEventTalk.dialog = true
						this.$store.state.loading = false
					})
				} else {
					this.$store.state.loading = false
					this.startDialog.dialog = false
					this.alertModal2.text = '본 이벤트는 종료되었습니다.'
					this.alertModal2.dialog = true
				}
			})
		},
		// 생성 / 수정시 알림톡
		creaetSendMessage() {
			const data = {
				// 필수값

				code: this.$route.params.code,
				sender: this.eventsData.callerNumber ? this.eventsData.callerNumber : process.env.VUE_APP_SENDER,
				senderkey: process.env.VUE_APP_SENDERKEY,
				tpl_code: this.eventsData.message.tplCode,
				receiver_1: this.reserveDialog.inputUserData.phone,
				subject_1: this.eventsData.message.tplCodeStr,
				message_1: this.eventsData.message.message,
				// 여기까지 필수값
				// apikey: this.$store.state.apikey,
				// userid: this.$store.state.userid,
				recvname_1: this.reserveDialog.inputUserData.name,
				failover: 'Y',
				fsubject_1: this.eventsData.message.tplCodeStr,
				fmessage_1: this.eventsData.message.message,
				button_1: this.eventsData.message.button ? this.eventsData.message.button : '[]',
				pay: this.eventsData.business?.id,
			}
			this.$store
				.dispatch('createSendMessage', data)
				.then(() => {})
				.catch(() => {})
		},
	},
}
</script>

<style lang="scss">
.reserve-background-width {
	width: 100%;
	max-width: 600px;
	margin: 0 auto;
}
.imageButton {
	text-align: end;
	padding: 20px;
}
.startVisit {
	background: white !important;
	padding: 20px 0px;
}
.cardTitle {
	font-size: 18px;
	font-weight: bold;
	text-align: center;
}
.guide {
	font-size: 13px;
	font-weight: bold;
	color: #606060;
}
.dialogBottom {
	.title {
		height: 50px;
		display: flex;
		align-items: center;
		text-align: center;
		background-color: #fdc85a;
		padding: 0 10px 0 30px;

		h2 {
			color: white;
			font-weight: bold;
			font-size: 18px;
		}

		.title-icon {
			color: white;
		}
	}
	.dialog-content {
		padding: 20px 20px 20px 20px;
	}
}
.hiddenTab {
	display: none;
}
</style>
<style lang="scss" scoped>
.reserveInfo {
	font-size: 14px;
	font-weight: bold;
	padding: 16px 16px 0px;
	color: #808080;
}
.duplicateInfo {
	font-size: 15px;
	margin-left: 16px;
	color: #808080;
}
</style>
